<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-img :src="require('../../../assets/our_service/lead-service3.jpg')" style="border-radius: 4px;"></v-img>
    <v-row class="my-10" align="center" justify="center">
      <v-col class="text-center">
        <span class="text-tcdc-green header bold">{{$t('our-service.transform')}}</span>
      </v-col>
    </v-row>
    <v-layout column>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service3-00.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="sub-header2 text-tcdc-grey1 d-flex align-center">
            {{$t('our-service.transform-content')}}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service3-01.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Creative Business Service</div>
              <div class=" text-tcdc-grey1">
                {{$t('our-service.transform-detail.creative-business')}}
                <ul>
                  <li>Change by Design</li>
                  <li>Consultation</li>
                  <li>Customized Workshop for Organizations</li>
                  <li>D.R.I.V.E</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service3-02.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Material & Design Innovation Center</div>
              <div class=" text-tcdc-grey1">
                {{$t('our-service.transform-detail.material-design')}}
                <ul>
                  <li>Design Innovation Consultation</li>
                  <li>Material Consultation</li>
                  <li>Innovation Matching</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service3-03.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Maker Space</div>
              <div class=" text-tcdc-grey1">
                {{$t('our-service.transform-detail.maker-space')}}
                <ul>
                  <li>Rapid Prototype</li>
                  <li>Product Develop Consultation</li>
                  <li>Maker Community</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service3-04.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Resource Center</div>
              <div class=" text-tcdc-grey1">
                TCDC Resource Center - {{$t('our-service.transform-detail.resource-center')}}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GreenButton from "../../../components/buttons/GreenButton";
import { mapState } from "vuex";

export default {
  components: {
    // GreenButton
  },
  created() {
    this.items[0].text = this.branchName;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  methods: {
    openLink(link) {
      window.open(link);
    },
    routeTo(target) {
      this.$router.push(target);
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        href: "/home"
      },
      {
        text: "OUR SERVICE",
        href: '/our-service'
      },
      {
        text: "BUSINESS TRANSFORMATION",
        disabled: true
      }
    ]
  })
};
</script>

<style scoped lang="scss">
  .txt-link {
    cursor: pointer;
  }
  .txt-link:hover {
    color: #2e8037;
  }
</style>
